import { createApi } from '@reduxjs/toolkit/query/react';
import { isUndefined } from 'lodash';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const menuApi = createApi({
  reducerPath: 'menuApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  tagTypes: ['Menu'],

  endpoints: (builder) => ({
    saveMenu: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.menuDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.menu,
            method: 'POST',
            data: req.body,
          };
        }
      },
      invalidatesTags: ['Menu'],
    }),

    saveMenuItemsOrder: builder.mutation({
      query: (req) => {
        return {
          url: urls.menuOrder,
          method: 'POST',
          data: {
            items: [
              ...req.menuData.map((item) => ({
                id: item.id,
                children: !item.children
                  ? null
                  : item.children.map((secondLevel) => ({
                      id: secondLevel.id,
                      children: !secondLevel.children
                        ? null
                        : secondLevel.children.map((thirdLevel) => ({
                            id: thirdLevel.id,
                            children: !thirdLevel.children
                              ? null
                              : thirdLevel.children.map((fourthLevel) => ({
                                  id: fourthLevel.id,
                                  children: null,
                                })),
                          })),
                    })),
              })),
            ],
            isEnglish: req.isEnglish,
          },
        };
      },
      invalidatesTags: ['Menu'],
    }),

    getMenuTree: builder.query({
      query: (isEnglish) => ({
        url: urls.menuTree(isEnglish),
      }),
      providesTags: ['Menu'],
    }),

    getMenu: builder.query({
      query: () => ({
        url: urls.menu,
      }),
      providesTags: ['Menu'],
    }),

    getMenuItem: builder.query({
      query: (id) => ({
        url: isUndefined(id) ? null : urls.menuDetail(id),
      }),
    }),

    deleteMenuItem: builder.mutation({
      query: (id) => ({
        url: urls.menuDetail(id),
        method: 'DELETE',
      }),
      invalidatesTags: ['Menu'],
    }),
  }),
});

export const {
  useSaveMenuMutation,
  useSaveMenuItemsOrderMutation,
  useGetMenuTreeQuery,
  useGetMenuQuery,
  useDeleteMenuItemMutation,
  useGetMenuItemQuery,
} = menuApi;
